import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedQuotation: null,
  isQuatationResponse: false,
  customerLeads: null,
  customerLeadDetails: null,
  customerSurveyDetails: null,
  customerQuoteDetails: null,
  customerConfirmDetails: null,
  isCustomerQuoteUpdated: false,
  customerMergeList: null,
  isCustomerMergeResponse: false,
  customerSettingResponse: null,
  isCustomerSettingResponse: false,
  isResetCustomerLinkResponse: false,
  isRequestSurveyStart: false,
  customerConfirmQuoteDetails: null,
};



const customerSlice = createSlice({
  name: "customer",
  initialState,

  reducers: {
    getQuotationAction: (state) => {},
    setQuotationAction: (state, { payload }) => {
      state.selectedQuotation = payload;
    },

    updateQuatationAction: (state, { payload }) => {},
    setUpdateQuatationAction: (state, { payload }) => {
      state.isQuatationResponse = payload;
    },

    getCustomerLeadsAction: (state) => {},
    setCustomerLeadsAction: (state, { payload }) => {
      const { pagination = { currentPage: 1 }, list = [] } = payload;
      state.customerLeads = list;
    },

    getCustomerLeadDetailsAction: (state, { payload }) => {},
    setCustomerLeadDetailsAction: (state, { payload }) => {
      state.customerLeadDetails = payload;
    },

    getCustomerSurveyDetailsAction: (state, { payload }) => {},
    setCustomerSurveyDetailsAction: (state, { payload }) => {
      state.customerSurveyDetails = payload;
    },

    getCustomerQuoteDetailsAction: (state, { payload }) => {},
    setCustomerQuoteDetailsAction: (state, { payload }) => {
      state.customerQuoteDetails = payload;
    },
    getCustomerConfirmDetailsAction: (state, { payload }) => {},
    setCustomerConfirmDetailsAction: (state, { payload }) => {
      state.customerConfirmDetails = payload;
    },

    updateCustomerQuote: (state, { payload }) => {},
    setUpdateCustomerQuote: (state, { payload }) => {
      state.isCustomerQuoteUpdated = payload;
    },

    getCustomerMergeListAction: (state, { payload }) => {},
    setCustomerMergeListAction: (state, { payload }) => {
      state.customerMergeList = payload;
    },

    updateCustomerMergeAction: (state, { payload }) => {},
    setCustomerMergeResponseAction: (state, { payload }) => {
      state.isCustomerMergeResponse = payload;
    },

    getCustomerSettingResponseAction: (state) => {},
    setCustomerSettingResponseAction: (state, { payload }) => {
      state.customerSettingResponse = payload;
    },

    updateCustomerSettingAction: (state, { payload }) => {},
    setUpdateCustomerSettingAction: (state, { payload }) => {
      state.isCustomerSettingResponse = payload;
    },

    customerResendCustomerLike: (state, { payload }) => {},
    setCustomerResendCustomerResponse: (state, { payload }) => {
      state.isResetCustomerLinkResponse = payload;
    },

    getQuoteConfirmDetailsAction: (state, { payload }) => {},
    setQuoteConfirmDetailsAction: (state, { payload }) => {
      state.customerConfirmQuoteDetails = payload;
    },

    updateQuoteConfirmAction: (state, { payload }) => {},
    setUpdateQuoteConfirmAction: (state, { payload }) => {
      state.isCustomerQuoteUpdated = payload;
    },

    requestSurveyAction: (state, { payload }) => {},
    requestStartSurveyAction: (state, { payload }) => {},
    setRequestStartSurveyAction: (state, { payload }) => {
      state.isRequestSurveyStart = payload;
    },
  },
});

const {
  getQuotationAction,
  setQuotationAction,
  updateQuatationAction,
  setUpdateQuatationAction,
  getCustomerLeadsAction,
  setCustomerLeadsAction,
  getCustomerLeadDetailsAction,
  setCustomerLeadDetailsAction,
  getCustomerSurveyDetailsAction,
  setCustomerSurveyDetailsAction,
  getCustomerQuoteDetailsAction,
  setCustomerQuoteDetailsAction,
  getCustomerConfirmDetailsAction,
  setCustomerConfirmDetailsAction,
  updateCustomerQuote,
  setUpdateCustomerQuote,
  updateQuoteConfirmAction,
  setUpdateQuoteConfirmAction,
  requestSurveyAction,
  requestStartSurveyAction,
  setRequestStartSurveyAction,
  getCustomerMergeListAction,
  setCustomerMergeListAction,
  updateCustomerMergeAction,
  setCustomerMergeResponseAction,
  getCustomerSettingResponseAction,
  setCustomerSettingResponseAction,
  updateCustomerSettingAction,
  setUpdateCustomerSettingAction,
  customerResendCustomerLike,
  setCustomerResendCustomerResponse,
  getQuoteConfirmDetailsAction,
  setQuoteConfirmDetailsAction,
} = customerSlice.actions;
export {
  getQuotationAction,
  setQuotationAction,
  updateQuatationAction,
  setUpdateQuatationAction,
  getCustomerLeadsAction,
  setCustomerLeadsAction,
  getCustomerLeadDetailsAction,
  setCustomerLeadDetailsAction,
  getCustomerSurveyDetailsAction,
  setCustomerSurveyDetailsAction,
  getCustomerQuoteDetailsAction,
  setCustomerQuoteDetailsAction,
  getCustomerConfirmDetailsAction,
  setCustomerConfirmDetailsAction,
  updateQuoteConfirmAction,
  setUpdateQuoteConfirmAction,
  requestSurveyAction,
  requestStartSurveyAction,
  setRequestStartSurveyAction,
  updateCustomerQuote,
  setUpdateCustomerQuote,
  getCustomerMergeListAction,
  setCustomerMergeListAction,
  updateCustomerMergeAction,
  setCustomerMergeResponseAction,
  getCustomerSettingResponseAction,
  setCustomerSettingResponseAction,
  updateCustomerSettingAction,
  setUpdateCustomerSettingAction,
  customerResendCustomerLike,
  setCustomerResendCustomerResponse,
  getQuoteConfirmDetailsAction,
  setQuoteConfirmDetailsAction,
};

export default customerSlice.reducer;
